import {
  GetSupplierHearingReplyItemSummaryRes
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class HearingReplyItemSummaryGateway {
  /** 業者ヒアリング回答確認-サマリ取得 */
  static getSupplierHearingReplyItemSummary = async (
    simulationYm: string,
    supplierCd: string,
    supplierBranchCd: string,
    factoryCd: string,
    expenseCd: string,
    graphSummaryFlag: number,
    displayStartYear: string
  ) => {
    const params = {
      simulationYm,
      supplierCd,
      supplierBranchCd,
      factoryCd,
      expenseCd,
      graphSummaryFlag,
      displayStartYear
    }
    return await yamadumiApi.get<GetSupplierHearingReplyItemSummaryRes>('/api/supplier/hearing/reply/item/summary', params)
  }
}
